module.exports = __webpack_public_path__ + "assets/img/tabs3.241f1c73.png";